<button
  class="btn btn__spinner {{ styleClasses }}"
  [disabled]="disabled || loading"
  [class.uppercase]="uppercase"
  (click)="onSubmit()">
  <span *ngIf="loading" class="spinner {{ loaderStyles }}">
    <loader [loading]="loading" [small]="true"></loader>
  </span>
  <ng-container *ngIf="iconPosition === 'before'">
    <i
      [matTooltipDisabled]="!tooltipText"
      [matTooltip]="tooltipText"
      *ngIf="withIcon && !loading"
      class="icon {{ iconClass }}"></i>
  </ng-container>
  {{ buttonLabel }}
  <ng-container *ngIf="iconPosition === 'after'">
    <i
      [matTooltipDisabled]="!tooltipText"
      [matTooltip]="tooltipText"
      *ngIf="withIcon && !loading"
      class="icon {{ iconClass }}"></i>
  </ng-container>
</button>
